/**
 * Change styles to accordion tabs.
 */
function tarjet_tab_accordion() {
    const tabs = document.querySelectorAll('[data-role="tab-accordion"]'),
        tabContents = document.querySelectorAll(".accordion__content");

    tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
            let target = document.querySelector(tab.dataset.target);
            const isActive = target.classList.contains("is-active");

            if (isActive) {
                // Close the active tab and content
                target.classList.remove("is-active");
                tab.classList.remove("is-active");
            } else {
                // Open the clicked tab and content, close others
                tabContents.forEach((tc) => {
                    tc.classList.remove("is-active");
                });
                target.classList.add("is-active");

                tabs.forEach((t) => {
                    t.classList.remove("is-active");
                });
                tab.classList.add("is-active");
            }
        });
    });

        // Open accordion item matching the URL hash on page load
        if (window.location.hash) {
            const hash = window.location.hash;
            const targetContent = document.querySelector(hash);
            if (targetContent && targetContent.classList.contains("accordion__content")) {
                // Find the corresponding tab
                const targetTab = Array.from(tabs).find(tab => tab.dataset.target === hash);
                if (targetTab) {
                    // Remove active from all
                    tabContents.forEach(tc => tc.classList.remove("is-active"));
                    tabs.forEach(t => t.classList.remove("is-active"));
                    // Activate the target
                    targetContent.classList.add("is-active");
                    targetTab.classList.add("is-active");
                }
            }
        }
}

tarjet_tab_accordion();

export default tarjet_tab_accordion;